import { HabitSchedule } from '@griply/types';
import { isAfter, startOfDay } from 'date-fns';

import { getScheduleEndDate } from './get-schedule-end-date';

// A legacy inverted-range schedule (endDate on/before its start day) governs zero days and must never bound a sibling.
export const isDegenerateSchedule = (
  schedule: Pick<HabitSchedule, 'startDate' | 'endDate'>,
) =>
  !!schedule.endDate &&
  isAfter(startOfDay(schedule.startDate), getScheduleEndDate(schedule)!);
